/** See `src/i18n/locales/en/manageSupport.ts`. */
export const manageSupport = {
  page: {
    title: 'Destek',
    lead: 'Platformdaki tüm destek talepleri, duruma ve önceliğe göre filtrelenebilir.',
    filterStatus: 'Durum',
    filterPriority: 'Öncelik',
    allStatuses: 'Tüm durumlar',
    allPriorities: 'Tüm öncelikler',
    empty: 'Bu filtrelerle eşleşen talep yok.',
    rowsLabel: 'talepler',
    subject: 'Konu',
    company: 'Şirket',
    status: 'Durum',
    priority: 'Öncelik',
    createdAt: 'Açıldı',
  },
  status: {
    open: 'Açık',
    in_progress: 'İşlemde',
    resolved: 'Çözüldü',
    closed: 'Kapalı',
  },
  priority: {
    low: 'Düşük',
    normal: 'Normal',
    high: 'Yüksek',
    urgent: 'Acil',
  },
  detail: {
    thisTicket: 'bu talep',
    requesterTitle: 'Talep eden',
    requesterLabel: 'talep eden kişi',
    controlsTitle: 'Durum ve öncelik',
    save: 'Kaydet',
    threadTitle: 'Görüşme',
    threadEmpty: 'Henüz mesaj yok.',
    replyLabel: 'Yanıt',
    reply: 'Yanıtı gönder',
  },
} as const;
